import AppLayout from "../components/layout/AppLayout";
import LabourTableComponent from "../components/labour/LabourTableComponent";

export default function Labour() {
  return (
    <AppLayout>
      <LabourTableComponent />
    </AppLayout>
  );
}
